<template>
<div class="chapter">
<div class="inner_page">
<div class="adCardPage" id="adc01">
<p class="adCardHead">ALSO BY ALEX SANCHEZ</p>
<p class="adCardText"><em class="italic">The God Box</em></p>
<p class="adCardText"><em class="italic">Getting It</em></p>
<p class="adCardText"><em class="italic">Rainbow Road</em></p>
<p class="adCardText"><em class="italic">Rainbow High</em></p>
<p class="adCardText"><em class="italic">Rainbow Boys</em></p>
<p class="adCardText1"><em class="italic">So Hard to Say</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416995050_adc01.vue?2acf70d1